import useTheme from '@/theme/useTheme';
import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useCountDown } from 'ahooks';
import { useTranslation } from 'next-i18next';

const BonusCountDown: React.FC<{
  countdown: string | number;
  titleText?: string
}> = ({ countdown, titleText }) => {
  const [t] = useTranslation();
  const { theme } = useTheme();
  const [, { days, hours, minutes, seconds }] = useCountDown({
    targetDate: Number(countdown) || '2099-12-31',
  });
  if (!countdown) {
    return null;
  }
  return (
    <Stack
      display={'grid'}
      gridTemplateColumns={
        '1fr min-content 1fr min-content 1fr min-content 1fr'
      }
      textAlign={'center'}
      justifyContent={'center'}
      alignItems={'center'}
      sx={{
        color: theme.palette.text.secondary,
        ['> p']: {
          color: 'inherit',
        },
      }}
    >
      <Typography variant="caption" gridColumn={'1/-1'} noWrap>
        {titleText || t('rewards::Welcome Bonus Expire In')}
      </Typography>
      <Typography fontSize={'18px'} fontWeight={500}>
        {String(days).padStart(2, '0')}
      </Typography>
      <Typography>:</Typography>
      <Typography fontSize={'18px'} fontWeight={500}>
        {String(hours).padStart(2, '0')}
      </Typography>
      <Typography>:</Typography>
      <Typography fontSize={'18px'} fontWeight={500}>
        {String(minutes).padStart(2, '0')}
      </Typography>
      <Typography>:</Typography>
      <Typography fontSize={'18px'} fontWeight={500}>
        {String(seconds).padStart(2, '0')}
      </Typography>
      <Typography variant="caption">{t('Days')}</Typography>
      <Typography></Typography>
      <Typography variant="caption">{t('Hours')}</Typography>
      <Typography></Typography>
      <Typography variant="caption">{t('Min')}</Typography>
      <Typography></Typography>
      <Typography variant="caption">{t('Sec')}</Typography>
    </Stack>
  );
};

export default BonusCountDown;
